/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PaymentTypeValues {
  PrePaiement = 'PrePaiement',
  PostPaiement = 'PostPaiement',
  Cash = 'Cash',
}
